<script>
  export let size = 200;
  export let percent = 0;
  export let bgColor = '#f55036';
  export let fgColor = '#1bc76a';
  export let innerColor = '#e6dcd7';
  export let textColor = '#1d1d1b';
  export let text = 'Job ready';
  
  $: viewBox = `0 0 ${size} ${size}`;
  
  $: radius = size / 2;
  $: halfCircumference = Math.PI * radius;
  $: pieSize = halfCircumference * (percent / 100);
  $: dashArray = `0 ${halfCircumference - pieSize} ${pieSize}`;
</script>

<svg width={size} height={size} {viewBox}>
  <circle r={radius} cx={radius} cy={radius} fill={bgColor} />
  <circle
    r={radius / 2}
    cx={radius}
    cy={radius}
    fill={bgColor}
    stroke={fgColor}
    stroke-width={radius}
    stroke-dasharray={dashArray}
  />
  <circle r={radius / 2} cx={radius} cy={radius} fill={innerColor} />
  <text x="50%" y="45%" fill="{textColor}" dominant-baseline="middle" text-anchor="middle">Poäng:</text>
  <text x="50%" y="55%" fill="{textColor}" dominant-baseline="middle" text-anchor="middle">{text}</text>
</svg>
